

import UpDownArrows from './UpDownArrows'
const AllCustomersCount = ({ticketsCount}) => {
    return (
        <div className="quickStats-block">
            <div>
                <h3>{ ticketsCount }</h3>
                <UpDownArrows />
            </div>
            <h5>Total Customers<br />Waiting</h5>
        </div>
    )
}

export default AllCustomersCount
